import React from "react";
import { AiOutlinePlusCircle } from "react-icons/ai";
import CreateVisaButton from "./CreateVisaButton";

function NoVisas() {
  return (
    <div className="w-full py-16 flex flex-col items-center justify-center text-center">
      <div className="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center mb-4">
        <AiOutlinePlusCircle size={64} className="text-gray-400" />
      </div>

      <h3 className="text-lg font-semibold mb-2">No Transit Visas Found</h3>
      <p className="text-gray-500 mb-6 max-w-xs">
        You have not created any transit visa yet. Click the button below to
        create your first visa.
      </p>

      <CreateVisaButton />
    </div>
  );
}

export default NoVisas;
